module.exports = __webpack_public_path__ + "media/assets/icons/plus_icon-8b475c453d236b16192614fc49a52f60.svg";